import { render, staticRenderFns } from "./r-tutorial-dropdown.vue?vue&type=template&id=79cdb422"
import script from "./r-tutorial-dropdown.vue?vue&type=script&lang=js"
export * from "./r-tutorial-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cdb422')) {
      api.createRecord('79cdb422', component.options)
    } else {
      api.reload('79cdb422', component.options)
    }
    module.hot.accept("./r-tutorial-dropdown.vue?vue&type=template&id=79cdb422", function () {
      api.rerender('79cdb422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/tutorial/r-tutorial-dropdown.vue"
export default component.exports